import React from 'react';
import { Box } from '@mui/material';
import MaintenanceDetailsDashboard from '../../components/maintenance/maintenanceVehicle/MaintenanceDetailsDashboard';

const MantenimientosVehiculoDetallePage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <MaintenanceDetailsDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de mantenimientos por vehiculo:', newOrder);
        }}
      />
    </Box>
  );
};

export default MantenimientosVehiculoDetallePage;